import { Delete } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo, useState } from "react";
import RequeridoLabel from "../../../../../../../commons/labels/RequeridoLabel";
import { tableConfig } from "../../../../../../../commons/table/tableConfig";
import { StyledResolucion } from '../../../../../../../styled/Prevencion';

const UsosTable = ({ data, handleOpenForm, handleDelete }) => {
    const [rowSelection, setRowSelection] = useState({});

    const columns = useMemo(() => [
        {
            accessorKey: "nombreUso",
            header: "Origen/Uso",
            size: 200,
        },
        {
            accessorKey: "nombreModoEmpleo",
            header: "Modo de Empleo",
            size: 200,
        },
    ], []);

    const table = useMaterialReactTable({
        columns,
        data: data || [],
        enableRowSelection: true,
        state: {
            rowSelection,
        },
        onRowSelectionChange: setRowSelection,
        enableRowActions: true,
        positionActionsColumn: "last",
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: 'Operaciones',
                size: 150,
            },
        },
        renderRowActions: ({ row }) => (
            <IconButton
                onClick={() => handleOpenForm({ ...row.original, index: row.index })}
                size="small"
                title="Editar registro"
            >
                <EditIcon />
            </IconButton>
        ),
        renderTopToolbarCustomActions: () => (
            <StyledResolucion.HeaderContainer>
                <StyledResolucion.TableTitle>
                    Usos
                </StyledResolucion.TableTitle>
                {!data.length && (
                    <RequeridoLabel text="Es obligatorio ingresar al menos un Origen/Uso" />
                )}
            </StyledResolucion.HeaderContainer>
        ),
        renderToolbarAlertBannerContent: ({ groupedAlert, selectedAlert, table }) => (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: 1,
                }}>
                {selectedAlert}
                <Tooltip title="Eliminar seleccionados">
                    <IconButton
                        onClick={() => {
                            const selectedRows = table.getSelectedRowModel().rows.map(row => row.index);
                            handleDelete(selectedRows);
                            table.resetRowSelection();
                        }}
                    >
                        <Delete />
                    </IconButton>
                </Tooltip>
            </Box>
        ),
        renderBottomToolbarCustomActions: () => (
            <StyledResolucion.TableFooterButtonContainer>
                <Button
                    color="primary"
                    onClick={() => handleOpenForm(null)}
                >
                    Agregar
                </Button>
            </StyledResolucion.TableFooterButtonContainer>
        ),
        muiPaginationProps: {
            labelRowsPerPage: "Filas por página:",
            getItemAriaLabel: (type) => {
                if (type === 'first') return 'ir a la primera página';
                if (type === 'last') return 'ir a la última página';
                if (type === 'next') return 'ir a la página siguiente';
                return 'ir a la página anterior';
            },
            labelDisplayedRows: ({ from, to, count }) => `${from}-${to} de ${count}`,
        },
        localization: {
            ...MRT_Localization_ES,
            noRecordsToDisplay: "No hay datos que mostrar",
            MRT_RowsSelected: '{0} Fila(s) seleccionadas',
        },
        initialState: {
            pagination: {
                pageSize: 5,
                pageIndex: 0,
            },
            density: 'compact',
        },
        enableGlobalFilter: false,
        enableColumnFilters: false,
        enableFilters: false,
        enableColumnActions: false,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        enableHiding: false,
        enablePagination: true,
        paginationDisplayMode: 'pages',
        muiTableHeadCellProps: {
            sx: { ...tableConfig.muiTableHeadCellProps?.sx }
        },
        muiTableBodyRowProps: {
            sx: { ...tableConfig.muiTableBodyRowProps?.sx }
        },
    });

    return (
        <>
            <StyledResolucion.TableContainer>
                <MaterialReactTable table={table} />
            </StyledResolucion.TableContainer>
        </>
    );
};

export default UsosTable;